<script setup>
import { BBadge } from 'bootstrap-vue-next';
</script>

<template>
  <div class="text-muted small mt-2">
    <span class="me-3">
      <BBadge variant="warning">SuperStar</BBadge>
      More than 75 merged MRs
    </span>
    <span class="me-3">
      <BBadge variant="info">Star</BBadge>
      Between 11 and 75 merged MRs
    </span>
    <span>
      <BBadge variant="secondary">Enthusiast</BBadge>
      Between 5 and 10 merged MRs
    </span>
  </div>
</template>
